import ReactGA from 'react-ga';

import {
  SEARCHING,
  SEARCH_COMPLETE,
  INPUT_CHANGE,
  POLLING,
  POLL_ERROR,
  POLL_TIMEOUT,
  LEAD_CREATED,
  REPORT_LOADED,
  LOADING,
  LOADING_COMPLETE,
  STAFF_CHECK,
  SEARCH_PARAM,
  DECRYPT_CUSTOMER_DATA
} from './constants';

import {
  createAxios,
  searchEndpoint,
  pollEndpoint,
  leadEndpoint,
  getUsfoodCustomerDataEndpoint,
  reportEndpoint,
  currentUserEndpoint,
} from 'app/helpers/api';

import { updateReportParam } from 'app/helpers/utils';
import { EMPLOYEE } from 'app/helpers/constants';

export const handleSearchParam = (param, value, type = SEARCH_PARAM) => {
  return {
    param,
    value,
    type
  };
};

export const checkIfStaff = () => async dispatch => {
  try {
    const response = await createAxios(true).get('current_user');
    const isStaff =
      response.data && response.data[0] ? response.data[0].is_staff : false;
    dispatch({ isStaff, type: STAFF_CHECK });
    return isStaff;
  } catch (error) {
    dispatch({ isStaff: false, type: STAFF_CHECK });
  }
};

export const loading = (entity = 'global', type = LOADING) => ({
  type,
  entity,
});

export const loadingComplete = (type = LOADING_COMPLETE) => ({ type });

export const loadReport = ref => async (dispatch, getState) => {
  dispatch(loading('report'));
  const { usFoods } = getState();
  const params = new URLSearchParams(window.location.search);
  const salesLinkQueryParam = params.get('saleslink');
  try {
    const response = await createAxios(true).get(pollEndpoint(ref), {
      params: { usFoods, salesLinkQueryParam },
    });
    dispatch({ report: response.data, type: REPORT_LOADED });
  } catch (error) {
    console.error(error);
  }
};

const pollError = (type = POLL_ERROR) => ({ type });

const pollTimeout = (type = POLL_TIMEOUT) => ({ type });

const poll = () => async (dispatch, getState) => {
  const {
    website: { ref },
    poll: { count: pollCount },
    usFoods,
    user: { userType }
  } = getState();
  const url = pollEndpoint(ref);
  // The number of polls, in seconds, that we will make before considering
  // the request having timed out.
  const maxAttempts = 60;
  dispatch({ type: POLLING });
  try {
    const response = await createAxios(true).get(url, {
      params: { usFoods },
    });
    const {
      complete,
      is_bentobox,
      staff_request: staffRequest,
      ref,
    } = response.data;
    if (complete) {
      // If this is a staff request, no lead will be created
      // and the user will automatically be directed to the report
      // once the search is complete (skipping the unlock form).
      // Normally this Report URL SearchParam gets updated when the
      // lead is created, so we must perform it here.
      if (staffRequest && !is_bentobox) updateReportParam(ref);

      dispatch({ data: response.data, type: SEARCH_COMPLETE });

      // for usFood users createLead should happen at the same time
      if (usFoods && userType && userType !== EMPLOYEE) {
        dispatch(createLead());
      }
    } else {
      // Continue to poll
      if (pollCount <= maxAttempts) setTimeout(() => dispatch(poll()), 1000);
      else {
        // Timeout
        //dispatch(pollTimeout());
        dispatch(pollError());
      }
    }
  } catch (error) {
    console.error(error);
    dispatch(pollError(false));
  }
};

export const search = (url = searchEndpoint) => async (dispatch, getState) => {
  dispatch(loading());
  const {
    website: { domain },
  } = getState();
  // Send this even within the action dispatcher in order
  // to access the domain directly from state
  ReactGA.event({
    category: 'Landing Page',
    action: 'URL Submitted',
    label: domain,
  });
  try {
    const response = await createAxios().post(url, { domain });
    const { id, ref } = response.data;
    dispatch({ domain, id, ref, type: SEARCHING });
    // Start Polling
    dispatch(poll());
  } catch (error) {
    console.error(error);
    dispatch(pollError());
  }
};

export const onInputChange = (
  model,
  field,
  value,
  transformer = foo => foo,
) => dispatch =>
  dispatch({ model, field, value: transformer(value), type: INPUT_CHANGE });

export const createLead = () => async (dispatch, getState) => {
  // dispatch a global load
  dispatch(loading());

  const {
    user: { name,
      email,
      restaurantName,
      zipcode,
      usfMarketName,
      usfEmployeeEmail,
      usfEmployeeName,
      usfCustomerId,
      userType,
      phone },
    grade: { id: gradeId, ref },
    search_params: utms,
    usFoods
  } = getState();

  let data = {
    name,
    email,
    restaurantName,
    gradeId,
    usFoods
  };

  if (usFoods) {
    data = {
      zipcode,
      usfMarketName,
      usfEmployeeEmail,
      usfEmployeeName,
      usfCustomerId,
      userType,
      phone,
      ...data
    };
  }

  if (utms.utm_source.length > 0) {
    data = { ...data, ...utms };
  }

  // create the lead
  try {
    const response = await createAxios().post(leadEndpoint(), data);
    const { funnel_type: funnelType, slug: leadSlug } = response.data;
    await dispatch({
      funnelType,
      leadSlug,
      type: LEAD_CREATED
    });
    // wait for the successful response then
    // update the url to contain the slug
    updateReportParam(ref);
  } catch (error) {
    console.error(error);
    dispatch(loadingComplete());
  }
};

export const getUsfoodCustomerData = (payload, iv) => async (dispatch) => {
  dispatch(loading());
  try {
    const response = await createAxios(true).get(getUsfoodCustomerDataEndpoint(), {
      params: { payload, iv }
    });
    dispatch({ data: response.data, type: DECRYPT_CUSTOMER_DATA });
    dispatch(loadingComplete());
  } catch (error) {
    console.error(error);
    dispatch(loadingComplete());
  }
};
